import RetributionConfigurationsService from "@/api/services/retributionConfigurations";
import { toCamelCase } from "@estaly/ui";

export default {
  namespaced: true,

  state: {
    selectedStoreId: null,
    retributionConfigurations: [],
    loadingRetributionConfigurations: false,
  },

  mutations: {
    setSelectedStoreId(state, storeId) {
      state.selectedStoreId = storeId;
    },

    setRetributionConfigurations(state, retributionConfigurations) {
      state.retributionConfigurations = retributionConfigurations;
    },

    setLoadingRetributionConfigurations(state, loadingRetributionConfigurations) {
      state.loadingRetributionConfigurations = loadingRetributionConfigurations;
    },
  },

  actions: {
    async fetchRetributionConfigurations(
      { state, commit },
      { matchedContractId = null, page = null, perPage = null } = {},
    ) {
      commit("setLoadingRetributionConfigurations", true);
      try {
        const response = await RetributionConfigurationsService.fetchIndex({
          storeId: state.selectedStoreId,
          matchedContractId,
          page,
          perPage,
        });
        if (!response?.success) return response;

        const data = toCamelCase(response.data);

        commit("setRetributionConfigurations", data.records);
        return response;
      } finally {
        commit("setLoadingRetributionConfigurations", false);
      }
    },

    async downloadRetributionConfigurationsPdf(_context, storeId) {
      await RetributionConfigurationsService.downloadPdf(storeId);
    },
  },
};
